<template>
  <!-- eslint-disable max-len -->
  <div
    class="wpromo-card"
    role="dialog"
    aria-modal="true"
    aria-label="Get the Wochit App"
  >
    <img
      class="wpromo-logo"
      src="/resources/img/wochit-white.png"
      alt="Wochit"
    />
    <div class="wpromo-kicker">GET THE APP</div>
    <h2 class="wpromo-title">
      Make branded<br />video, right from<br />your <span>phone.</span>
    </h2>
    <p class="wpromo-sub">
      Create, brand, and publish with Wochit Go. AI video studio in your pocket.
      On iPhone and Android.
    </p>
    <div class="wpromo-dl">
      <div class="wpromo-qr">
        <wochit-go-qr />
      </div>
      <div>
        <div class="wpromo-scan">Scan to download</div>
        <div class="wpromo-scan-sub">
          Opens the right store for your device.
        </div>
        <div class="wpromo-stores">
          <a
            class="wpromo-store"
            href="https://apps.apple.com/us/app/wochit-go/id1446752890"
            target="_blank"
            rel="noopener"
            @click="onStoreClick('appStore')"
          >
            <svg
              viewBox="0 0 384 512"
              width="14"
              height="14"
              fill="currentColor"
              style="margin-right: 7px"
            >
              <path
                d="M318.7 268.7c-.2-36.7 16.4-64.4 50-84.8-18.8-26.9-47.2-41.7-84.7-44.6-35.5-2.8-74.3 20.7-88.5 20.7-15 0-49.4-19.7-76.4-19.7C63.3 141.2 4 184.8 4 273.5q0 39.3 14.4 81.2c12.8 36.7 59 126.7 107.2 125.2 25.2-.6 43-17.9 75.8-17.9 31.8 0 48.3 17.9 76.4 17.9 48.6-.7 90.4-82.5 102.6-119.3-65.2-30.7-61.7-90-61.7-91.9zm-56.6-164.2c27.3-32.4 24.8-61.9 24-72.5-24.1 1.4-52 16.4-67.9 34.9-17.5 19.8-27.8 44.3-25.6 71.9 26.1 2 49.9-11.4 69.5-34.3z"
              />
            </svg>
            App Store
          </a>
          <a
            class="wpromo-store"
            href="https://play.google.com/store/apps/details?id=com.wochit.goapp"
            target="_blank"
            rel="noopener"
            @click="onStoreClick('googlePlay')"
          >
            <svg
              viewBox="0 0 512 512"
              width="14"
              height="14"
              fill="currentColor"
              style="margin-right: 7px"
            >
              <path
                d="M325.3 234.3 104.6 13l280.8 161.2-60.1 60.1zM47 0C34 6.8 25.3 19.2 25.3 35.3v441.3c0 16.1 8.7 28.5 21.7 35.3l256.6-256L47 0zm425.2 225.6-58.9-34.1-65.7 64.5 65.7 64.5 60.1-34.1c18-14.3 18-46.5-1.2-60.8zM104.6 499l220.7-221.3 60.1 60.1L104.6 499z"
              />
            </svg>
            Google Play
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WochitGoQr from 'components/WochitGoQr.vue';

export default {
  name: 'WtGetTheApp',

  components: {
    WochitGoQr,
  },

  props: {
    closeModal: { type: Function, default: () => {} },
    analytics: { type: Function, default: () => {} },
  },

  mounted() {
    this.analytics('getTheApp:modalOpen');
  },

  methods: {
    onStoreClick(store) {
      this.analytics('getTheApp:storeClick', { store });
    },
  },
};
</script>

<style lang="scss" scoped>
.wpromo-card {
  width: 560px;
  max-width: 92vw;
  box-sizing: border-box;
  padding: 44px 46px;
  border-radius: 18px;
  background: radial-gradient(
    120% 140% at 100% 0%,
    #23265e 0%,
    #12143a 45%,
    #0b0d1c 100%
  );
  color: #fff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.55);
}
.wpromo-logo {
  display: block;
  height: 30px;
  width: auto;
}
.wpromo-kicker {
  margin-top: 18px;
  color: #00aeef;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 2px;
}
.wpromo-kicker::before {
  content: '';
  display: block;
  width: 34px;
  height: 3px;
  background: #00aeef;
  border-radius: 2px;
  margin-bottom: 12px;
}
.wpromo-title {
  margin: 14px 0 0;
  font-size: 40px;
  line-height: 1.06;
  font-weight: 800;
  letter-spacing: -0.5px;
}
.wpromo-title span {
  color: #00aeef;
}
.wpromo-sub {
  margin: 16px 0 0;
  color: #b9bed6;
  font-size: 15px;
  line-height: 1.5;
  max-width: 430px;
}
.wpromo-dl {
  display: flex;
  align-items: center;
  gap: 22px;
  margin-top: 30px;
}
.wpromo-qr {
  background: #fff;
  padding: 4px;
  border-radius: 14px;
  line-height: 0;
  flex: 0 0 auto;
}
.wpromo-qr .wochit-go-qr {
  display: block;
  width: 150px;
  height: 150px;
}
.wpromo-scan {
  font-weight: 700;
  font-size: 17px;
}
.wpromo-scan-sub {
  color: #9aa0bd;
  font-size: 13px;
  margin-top: 4px;
}
.wpromo-stores {
  display: flex;
  gap: 10px;
  margin-top: 14px;
  flex-wrap: wrap;
}
.wpromo-store {
  display: inline-flex;
  align-items: center;
  height: 38px;
  padding: 0 16px;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  color: #fff;
  text-decoration: none;
  font-size: 13px;
  font-weight: 600;
  background: rgba(255, 255, 255, 0.04);
  transition: background 0.15s ease;
}
.wpromo-store:hover {
  background: rgba(255, 255, 255, 0.12);
}
</style>
